import React, { Fragment, useEffect, useState } from 'react'
import { Segment, Button, Label, Icon } from 'semantic-ui-react';
// store
import { authService } from "../../../../store/services/ServiceAuth";
import { sharedAccessService } from "../../../../store/services/ServiceSharedAccess";
// components
import HeaderTitle from "../../../../components/others/HeaderTitle";
import SharedAccessRequest from './SharedAccessRequest';
import SharedAccessTable from './SharedAccessTable';
import { toast } from '../../../../components/others/ToastContainer';

const SharedAccess = () => {
    authService.useIsAdmin();
    const [requests, setRequests] = useState([]);
    const [loading, setLoading] = useState(true);
    const [activeFilter, setActiveFilter] = useState('approved');
    const [stats, setStats] = useState({
        total: 0,
        pending: 0,
        approved: 0,
        denied: 0,
        released: 0
    });

    const fetchData = async (status = null) => {
        setLoading(true);
        const params = status ? "?status=" + status : "";
        const requestsResponse = await sharedAccessService.getSharedAccessRequests(params);

        // Fetch stats
        const statsResponse = await sharedAccessService.getSharedAccessRequestsStats();

        if (requestsResponse.status === 200) {
            setRequests(requestsResponse.response);
        }

        if (statsResponse.status === 200) {
            setStats(statsResponse.response);
        }

        if (requestsResponse.status === 400) {
            toast({
                type: 'error',
                message: 'Nepodarilo sa načítať žiadosti'
            });
        }

        if (statsResponse.status === 400) {
            toast({
                type: 'error',
                message: 'Nepodarilo sa načítať štatistiky'
            });
        }

        setLoading(false);
    };

    useEffect(() => {
        fetchData(activeFilter);
    }, [activeFilter]);

    const handleRelease = async (requestId) => {
        const request = await sharedAccessService.releaseSharedAccess(requestId);
        if (request.status === 200) {
            fetchData(activeFilter);
            toast({
                type: 'success',
                message: 'Prístup bol úspešne zrušený'
            });
        }

        if (request.status === 400 || request.status === 404 || request.status === 500) {
            toast({
                type: 'error',
                message: 'Nepodarilo sa zrušiť prístup'
            });
        }
    };

    const filterButtons = [
        { status: 'approved', label: 'Schválené', count: stats.approved, icon: 'check', color: 'green' },
        { status: 'pending', label: 'Čakajúce', count: stats.pending, icon: 'clock', color: 'yellow' },
        { status: 'denied', label: 'Zamietnuté', count: stats.denied, icon: 'times', color: 'red' },
        { status: 'released', label: 'Zrušené', count: stats.released, icon: 'stop', color: 'black' },
        { status: null, label: 'Všetky', count: stats.total, icon: 'list', color: 'blue' },
    ];

    return (
        <Fragment>
            <HeaderTitle title="Vzdialený prístup" />

            <section>
                <Segment>
                    <div style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        marginBottom: '1rem'
                    }}>
                        <div style={{ display: 'flex', gap: '0.5rem' }}>
                            {filterButtons.map(({ status, label, count, icon, color }) => (
                                <Button
                                    key={status || 'all'}
                                    active={activeFilter === status}
                                    color={activeFilter === status ? color : undefined}
                                    size="small"
                                    onClick={() => setActiveFilter(status)}
                                >
                                    <Icon name={icon} />
                                    {label}
                                    <Label circular size="small" style={{ marginLeft: '0.5rem' }}>
                                        {count}
                                    </Label>
                                </Button>
                            ))}
                        </div>
                        <SharedAccessRequest
                            setActiveFilter={setActiveFilter}
                            onRequestComplete={(status) => fetchData(status)}
                        />
                    </div>

                    <SharedAccessTable
                        requests={requests}
                        onRelease={handleRelease}
                        loading={loading}
                        activeFilter={activeFilter}
                        statuses={filterButtons}
                    />
                </Segment>
            </section>
        </Fragment>
    )
}

export default SharedAccess;